const GENERIC_BOM_ERROR = 'Error loading BOM data. Please try again.';

function firstNonEmptyString(...values: any[]): string | undefined {
  for (const value of values) {
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed) {
        return trimmed;
      }
    }
    if (Array.isArray(value) && value.length) {
      const nested = firstNonEmptyString(value[0]);
      if (nested) {
        return nested;
      }
    }
  }
  return undefined;
}

/**
 * Resolve the user-facing message for a failed BOM fetch.
 * Celery/websocket failures pass the exception string as the error payload
 * (e.g. "Structure is not feasible, please change module dimension or module tilt").
 */
export function getBomFailureMessage(error: any, loaderMsg?: string): string {
  if (typeof error === 'string') {
    return firstNonEmptyString(error) || firstNonEmptyString(loaderMsg) || GENERIC_BOM_ERROR;
  }

  const fromBackend = firstNonEmptyString(
    error?.response?.error_message,
    error?.response?.result,
    error?.result,
    typeof error?.response === 'string' ? error.response : undefined,
  );

  if (fromBackend) {
    return fromBackend;
  }

  const fromMessage = firstNonEmptyString(error?.message);
  if (fromMessage && !/^ajax error/i.test(fromMessage)) {
    return fromMessage;
  }

  return firstNonEmptyString(loaderMsg) || GENERIC_BOM_ERROR;
}
